exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes _message__fade-in__kW7kI {\n  from {\n    opacity: 0;\n    transform: translate(0, -25%); }\n  to {\n    opacity: 1;\n    transform: translate(0, 0); } }\n\n@keyframes _message__countdown__1Cx5j {\n  from {\n    width: 0; }\n  to {\n    width: 100%; } }\n\n._message__container__1yskU {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1070; }\n\n._message__message__qCrr_ {\n  position: relative;\n  margin: 0.5rem auto 0;\n  max-width: 30rem;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  animation: _message__fade-in__kW7kI .3s ease-out;\n  padding: 0.5rem 1rem; }\n\n._message__countdown__1Cx5j {\n  right: 0;\n  top: 0;\n  height: 100%;\n  position: absolute;\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: inherit;\n  animation-name: _message__countdown__1Cx5j;\n  animation-timing-function: linear;\n  z-index: 0; }\n", ""]);

// exports
exports.locals = {
	"container": "_message__container__1yskU",
	"message": "_message__message__qCrr_",
	"fade-in": "_message__fade-in__kW7kI",
	"countdown": "_message__countdown__1Cx5j"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/_message.scss
// module id = 396
// module chunks = 0 1